import React from 'react'
import Header2 from '../../components/shared/Header2'
import Footer2 from '../../components/shared/Footer2'
import top1 from '../../assets/new-image/hero-right.png';
import top2 from '../../assets/new-image/hero-left.png';
import question from '../../assets/about/question.png';
import girl from '../../assets/about/girl.png';
import foldright from '../../assets/about/fold-right.png';
import foldleft from '../../assets/about/fold-left.png';
import top3 from '../../assets/new-image/new-bg.png';
import girl2 from '../../assets/about/girl2.png';
import pageLeft from '../../assets/about/page-left.png';
import moon from '../../assets/about/moon.png';
import saturn from '../../assets/about/saturn.png';
import boy from '../../assets/about/boy.png';
import tab2 from '../../assets/about/tab-2.png';
import rocate from '../../assets/about/rocate.png';
function TermsandCondition() {
    return (
        <div>
            <Header2 />

            {/* about banner start*/}
            <section className="bg-banner-home relative " >
                <div className='max-w-7xl lg:px-0 px-4 mx-auto'>
                    <div className="flex lg:flex-row flex-col items-center justify-between gap-8 lg:pt-[133px] lg:pb-20 pt-10">
                        <div className='lg:max-w-[900px] mx-auto'>
                            <div className='top-image-1 lg:block hidden w-full absolute lg:-top-[20%] left-0 z-[-1]'>
                                <img src={top3} className='w-full h-auto object-contain' alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='pt-5 relative lg:px-0 px-4 '>
                <div>
                    <h3 className='text-[#191919] text-lg  lg:text-[26px] font-bold ff-pop text-center'>Terms & Condition</h3>
                </div>
                <p className='font-normal lg:text-lg text-center text-base tracking-[-3%] text-[#40566D] lg:max-w-[900px] mt-2.5 mx-auto ff-inter'>
                    Welcome to Third Bracket! By accessing our website and using our services, you agree to be bound by the following Terms and Conditions. Please read them carefully. If you do not agree with any part of these terms, you must not use our services.
                </p>
                <div className='flex flex-col-reverse lg:flex-row items-center justify-between mx-auto max-w-[1150px] gap-10 lg:gap-20'>
                    <div>
                        <div className='lg:mt-20'>
                            <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>1. Acceptance of Terms</h3>
                            <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                                By accessing or using Third Bracket’s services, you confirm that you have read, understood, and agree to these Terms and Conditions. These terms apply to all visitors, users, and others who access or use our services.
                            </p>
                        </div>
                        <div className='mt-10 lg:mt-20'>
                            <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>2. Services</h3>
                            <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                                Third Bracket provides HR technology solutions designed to streamline human resources processes. These services may be updated from time to time and may include software applications, tools, and resources.
                            </p>
                        </div>
                        <div className='mt-10 lg:mt-20'>
                            <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>3. User Accounts</h3>
                            <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                                To access certain features of our services, you may need to create an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete. You are responsible for safeguarding your password and for any activities or actions under your account.
                            </p>
                        </div>

                    </div>
                    <div className='flex items-start justify-end'>
                        <img src={girl2} alt="w-full h-auto object-contain" />
                    </div>
                </div>
                <div className='flex flex-col lg:flex-col my-10 lg:my-20 items-start justify-between mx-auto max-w-[1150px]  gap-10 lg:gap-20'>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>4. Use of Services</h3>
                        <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            You agree to use our services only for lawful purposes and in accordance with these Terms. You must not use our services:
                        </p>
                        <ul className='list-disc mb-0'>
                            <li className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter'>
                                In any way that violates any applicable federal, state, local, or international law or regulation.
                            </li>
                            <li className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter'>
                                For the purpose of exploiting, harming, or attempting to exploit or harm others, including minors.
                            </li>
                            <li className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] mb-1 ff-inter'>To transmit or procure the sending of any advertising or promotional material, including any "junk mail," "chain letter," "spam," or any other similar solicitation.</li>
                        </ul>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>5. Intellectual Property Rights</h3>
                        <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            All content, trademarks, and other intellectual property associated with our services are the property of Third Bracket or our licensors. You are granted a non-exclusive, non-transferable, revocable license to access and use our services solely for personal or internal business use.
                        </p>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>6. Disclaimers</h3>
                        <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            Our services are provided on an "as-is" and "as-available" basis. Third Bracket makes no representations or warranties of any kind, express or implied, regarding the operation of our services or the information, content, materials, or products included therein. You expressly agree that your use of our services is at your sole risk.
                        </p>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>7. Limitation of Liability</h3>
                        <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            To the fullest extent permitted by law, Third Bracket shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our services, including but not limited to loss of profits, data, or goodwill.
                        </p>
                    </div>
                    <div className='flex-1'>
                        <h3 className='text-[#191919] text-lg lg:text-xl font-bold ff-pop text-left'>8. Indemnification</h3>
                        <p className='font-normal lg:text-lg text-left text-base  text-[#626262] lg:max-w-[900px] my-5 mx-auto ff-inter'>
                            You agree to defend, indemnify, and hold harmless Third Bracket, its affiliates, licensors, and service providers, and its and their respective officers, directors, employees, contractors, agents, licensors, suppliers, successors, and assigns from and against any claims.
                        </p>
                    </div>
                </div>
            </div>
            {/* about banner end */}

            {/* Why Use Third Bracket start */}
            <Footer2 />
        </div>
    )
}

export default TermsandCondition